module.exports = __webpack_public_path__ + "img/DSC_0039.88d78237.jpg";